export default __webpack_public_path__ + "static/media/FlagOfUnitedKingdom.9e9c0fd4.svg";